import React from 'react';

type Props = {
  totalPages: number;
  currentPage: number;
  setPage: (page: number) => void;
}

const Thumbpages = ({ totalPages, currentPage, setPage }: Props) => (
  <div className="thumbpages">
    {Array.from({ length: totalPages }, (_, i) => (
      <div onClick={() => setPage?.(i + 1)} className={`each-thumb ${i === currentPage - 1 ? 'active-page' : ''}`}>
        <span />
      </div>
    ))}
  </div>
);

export default Thumbpages;
